import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();
    filterCartUpsells();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

async function filterCartUpsells() {
  const cart = await fetch('/cart.js').then(r => r.json());
  const cartProductIds = cart.items.map(i => i.product_id);

  let visibleCount = 0;

  document.querySelectorAll('.cart-upsell-item').forEach(item => {
    const productId = Number(item.dataset.productId);

    if (cartProductIds.includes(productId)) {
      item.remove();
    } else {
      visibleCount++;
    }
  });

  const container = document.querySelector('.cart-drawer-upsell');
  if (container) {
    container.hidden = visibleCount === 0;
  }
}

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.cart-upsell-add');
  if (!btn) return;

  let variantId = btn.dataset.variantId;

  if (!variantId) {
    const select = btn
      .closest('.cart-upsell-item')
      ?.querySelector('.cart-upsell-variant');

    if (!select) return;
    variantId = select.value;
  }

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  });

  filterCartUpsells();
});